var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticStyle:{"white-space":"nowrap"},on:{"click":_vm.tap}},[(_vm.$store.state.bpm)?[_vm._v(" "+_vm._s(_vm.$store.state.bpm)+" ")]:_vm._e(),[_vm._v(" bpm ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }